import { __extends } from "tslib";
import { WebRequest } from './webRequest';
import { DomManagement } from './domManagement';
import { Observable } from './observable';
import { FilesInputStore } from './filesInputStore';
import { RetryStrategy } from './retryStrategy';
import { BaseError } from './baseError';
import { StringTools } from './stringTools';
import { ThinEngine } from '../Engines/thinEngine';
import { ShaderProcessor } from '../Engines/Processors/shaderProcessor';
/** @ignore */
var LoadFileError = /** @class */ (function (_super) {
    __extends(LoadFileError, _super);
    /**
     * Creates a new LoadFileError
     * @param message defines the message of the error
     * @param request defines the optional web request
     * @param file defines the optional file
     */
    function LoadFileError(message, object) {
        var _this = _super.call(this, message) || this;
        _this.name = "LoadFileError";
        BaseError._setPrototypeOf(_this, LoadFileError.prototype);
        if (object instanceof WebRequest) {
            _this.request = object;
        }
        else {
            _this.file = object;
        }
        return _this;
    }
    return LoadFileError;
}(BaseError));
export { LoadFileError };
/** @ignore */
var RequestFileError = /** @class */ (function (_super) {
    __extends(RequestFileError, _super);
    /**
     * Creates a new LoadFileError
     * @param message defines the message of the error
     * @param request defines the optional web request
     */
    function RequestFileError(message, request) {
        var _this = _super.call(this, message) || this;
        _this.request = request;
        _this.name = "RequestFileError";
        BaseError._setPrototypeOf(_this, RequestFileError.prototype);
        return _this;
    }
    return RequestFileError;
}(BaseError));
export { RequestFileError };
/** @ignore */
var ReadFileError = /** @class */ (function (_super) {
    __extends(ReadFileError, _super);
    /**
     * Creates a new ReadFileError
     * @param message defines the message of the error
     * @param file defines the optional file
     */
    function ReadFileError(message, file) {
        var _this = _super.call(this, message) || this;
        _this.file = file;
        _this.name = "ReadFileError";
        BaseError._setPrototypeOf(_this, ReadFileError.prototype);
        return _this;
    }
    return ReadFileError;
}(BaseError));
export { ReadFileError };
/**
 * @hidden
 */
var FileTools = /** @class */ (function () {
    function FileTools() {
    }
    /**
     * Removes unwanted characters from an url
     * @param url defines the url to clean
     * @returns the cleaned url
     */
    FileTools._CleanUrl = function (url) {
        url = url.replace(/#/mg, "%23");
        return url;
    };
    /**
     * Sets the cors behavior on a dom element. This will add the required Tools.CorsBehavior to the element.
     * @param url define the url we are trying
     * @param element define the dom element where to configure the cors policy
     */
    FileTools.SetCorsBehavior = function (url, element) {
        if (url && url.indexOf("data:") === 0) {
            return;
        }
        if (FileTools.CorsBehavior) {
            if (typeof (FileTools.CorsBehavior) === 'string' || this.CorsBehavior instanceof String) {
                element.crossOrigin = FileTools.CorsBehavior;
            }
            else {
                var result = FileTools.CorsBehavior(url);
                if (result) {
                    element.crossOrigin = result;
                }
            }
        }
    };
    /**
     * Loads an image as an HTMLImageElement.
     * @param input url string, ArrayBuffer, or Blob to load
     * @param onLoad callback called when the image successfully loads
     * @param onError callback called when the image fails to load
     * @param offlineProvider offline provider for caching
     * @param mimeType optional mime type
     * @returns the HTMLImageElement of the loaded image
     */
    FileTools.LoadImage = function (input, onLoad, onError, offlineProvider, mimeType) {
        if (mimeType === void 0) { mimeType = ""; }
        var url;
        var usingObjectURL = false;
        if (input instanceof ArrayBuffer || ArrayBuffer.isView(input)) {
            if (typeof Blob !== 'undefined') {
                url = URL.createObjectURL(new Blob([input], { type: mimeType }));
                usingObjectURL = true;
            }
            else {
                url = "data:" + mimeType + ";base64," + StringTools.EncodeArrayBufferToBase64(input);
            }
        }
        else if (input instanceof Blob) {
            url = URL.createObjectURL(input);
            usingObjectURL = true;
        }
        else {
            url = FileTools._CleanUrl(input);
            url = FileTools.PreprocessUrl(input);
        }
        if (typeof Image === "undefined") {
            FileTools.LoadFile(url, function (data) {
                createImageBitmap(new Blob([data], { type: mimeType })).then(function (imgBmp) {
                    onLoad(imgBmp);
                    if (usingObjectURL) {
                        URL.revokeObjectURL(url);
                    }
                }).catch(function (reason) {
                    if (onError) {
                        onError("Error while trying to load image: " + input, reason);
                    }
                });
            }, undefined, offlineProvider || undefined, true, function (request, exception) {
                if (onError) {
                    onError("Error while trying to load image: " + input, exception);
                }
            });
            return null;
        }
        var img = new Image();
        FileTools.SetCorsBehavior(url, img);
        var loadHandler = function () {
            img.removeEventListener("load", loadHandler);
            img.removeEventListener("error", errorHandler);
            onLoad(img);
            // Must revoke the URL after calling onLoad to avoid security exceptions in
            // certain scenarios (e.g. when hosted in vscode).
            if (usingObjectURL && img.src) {
                URL.revokeObjectURL(img.src);
            }
        };
        var errorHandler = function (err) {
            img.removeEventListener("load", loadHandler);
            img.removeEventListener("error", errorHandler);
            if (onError) {
                var inputText = input.toString();
                onError("Error while trying to load image: " + (inputText.length < 32 ? inputText : inputText.slice(0, 32) + "..."), err);
            }
            if (usingObjectURL && img.src) {
                URL.revokeObjectURL(img.src);
            }
        };
        img.addEventListener("load", loadHandler);
        img.addEventListener("error", errorHandler);
        var noOfflineSupport = function () {
            img.src = url;
        };
        var loadFromOfflineSupport = function () {
            if (offlineProvider) {
                offlineProvider.loadImage(url, img);
            }
        };
        if (url.substr(0, 5) !== "data:" && offlineProvider && offlineProvider.enableTexturesOffline) {
            offlineProvider.open(loadFromOfflineSupport, noOfflineSupport);
        }
        else {
            if (url.indexOf("file:") !== -1) {
                var textureName = decodeURIComponent(url.substring(5).toLowerCase());
                if (FilesInputStore.FilesToLoad[textureName]) {
                    try {
                        var blobURL;
                        try {
                            blobURL = URL.createObjectURL(FilesInputStore.FilesToLoad[textureName]);
                        }
                        catch (ex) {
                            // Chrome doesn't support oneTimeOnly parameter
                            blobURL = URL.createObjectURL(FilesInputStore.FilesToLoad[textureName]);
                        }
                        img.src = blobURL;
                        usingObjectURL = true;
                    }
                    catch (e) {
                        img.src = "";
                    }
                    return img;
                }
            }
            noOfflineSupport();
        }
        return img;
    };
    /**
     * Reads a file from a File object
     * @param file defines the file to load
     * @param onSuccess defines the callback to call when data is loaded
     * @param onProgress defines the callback to call during loading process
     * @param useArrayBuffer defines a boolean indicating that data must be returned as an ArrayBuffer
     * @param onError defines the callback to call when an error occurs
     * @returns a file request object
     */
    FileTools.ReadFile = function (file, onSuccess, onProgress, useArrayBuffer, onError) {
        var reader = new FileReader();
        var request = {
            onCompleteObservable: new Observable(),
            abort: function () { return reader.abort(); },
        };
        reader.onloadend = function (e) { return request.onCompleteObservable.notifyObservers(request); };
        if (onError) {
            reader.onerror = function (e) {
                onError(new ReadFileError("Unable to read " + file.name, file));
            };
        }
        reader.onload = function (e) {
            //target doesn't have result from ts 1.3
            onSuccess(e.target['result']);
        };
        if (onProgress) {
            reader.onprogress = onProgress;
        }
        if (!useArrayBuffer) {
            // Asynchronous read
            reader.readAsText(file);
        }
        else {
            reader.readAsArrayBuffer(file);
        }
        return request;
    };
    /**
     * Loads a file from a url
     * @param url url to load
     * @param onSuccess callback called when the file successfully loads
     * @param onProgress callback called while file is loading (if the server supports this mode)
     * @param offlineProvider defines the offline provider for caching
     * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
     * @param onError callback called when the file fails to load
     * @returns a file request object
     */
    FileTools.LoadFile = function (url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
        // If file and file input are set
        if (url.indexOf("file:") !== -1) {
            var fileName = decodeURIComponent(url.substring(5).toLowerCase());
            if (fileName.indexOf('./') === 0) {
                fileName = fileName.substring(2);
            }
            var file = FilesInputStore.FilesToLoad[fileName];
            if (file) {
                return FileTools.ReadFile(file, onSuccess, onProgress, useArrayBuffer, onError ? function (error) { return onError(undefined, new LoadFileError(error.message, error.file)); } : undefined);
            }
        }
        return FileTools.RequestFile(url, function (data, request) {
            onSuccess(data, request ? request.responseURL : undefined);
        }, onProgress, offlineProvider, useArrayBuffer, onError ? function (error) {
            onError(error.request, new LoadFileError(error.message, error.request));
        } : undefined);
    };
    /**
     * Loads a file
     * @param url url to load
     * @param onSuccess callback called when the file successfully loads
     * @param onProgress callback called while file is loading (if the server supports this mode)
     * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
     * @param onError callback called when the file fails to load
     * @param onOpened callback called when the web request is opened
     * @returns a file request object
     */
    FileTools.RequestFile = function (url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError, onOpened) {
        url = FileTools._CleanUrl(url);
        url = FileTools.PreprocessUrl(url);
        var loadUrl = FileTools.BaseUrl + url;
        var aborted = false;
        var fileRequest = {
            onCompleteObservable: new Observable(),
            abort: function () { return aborted = true; },
        };
        var requestFile = function () {
            var request = new WebRequest();
            var retryHandle = null;
            fileRequest.abort = function () {
                aborted = true;
                if (request.readyState !== (XMLHttpRequest.DONE || 4)) {
                    request.abort();
                }
                if (retryHandle !== null) {
                    clearTimeout(retryHandle);
                    retryHandle = null;
                }
            };
            var retryLoop = function (retryIndex) {
                request.open('GET', loadUrl);
                if (onOpened) {
                    onOpened(request);
                }
                if (useArrayBuffer) {
                    request.responseType = "arraybuffer";
                }
                if (onProgress) {
                    request.addEventListener("progress", onProgress);
                }
                var onLoadEnd = function () {
                    request.removeEventListener("loadend", onLoadEnd);
                    fileRequest.onCompleteObservable.notifyObservers(fileRequest);
                    fileRequest.onCompleteObservable.clear();
                };
                request.addEventListener("loadend", onLoadEnd);
                var onReadyStateChange = function () {
                    if (aborted) {
                        return;
                    }
                    // In case of undefined state in some browsers.
                    if (request.readyState === (XMLHttpRequest.DONE || 4)) {
                        // Some browsers have issues where onreadystatechange can be called multiple times with the same value.
                        request.removeEventListener("readystatechange", onReadyStateChange);
                        if ((request.status >= 200 && request.status < 300) || (request.status === 0 && (!DomManagement.IsWindowObjectExist() || FileTools.IsFileURL()))) {
                            onSuccess(useArrayBuffer ? request.response : request.responseText, request);
                            return;
                        }
                        var retryStrategy = FileTools.DefaultRetryStrategy;
                        if (retryStrategy) {
                            var waitTime = retryStrategy(loadUrl, request, retryIndex);
                            if (waitTime !== -1) {
                                // Prevent the request from completing for retry.
                                request.removeEventListener("loadend", onLoadEnd);
                                request = new WebRequest();
                                retryHandle = setTimeout(function () { return retryLoop(retryIndex + 1); }, waitTime);
                                return;
                            }
                        }
                        var error = new RequestFileError("Error status: " + request.status + " " + request.statusText + " - Unable to load " + loadUrl, request);
                        if (onError) {
                            onError(error);
                        }
                    }
                };
                request.addEventListener("readystatechange", onReadyStateChange);
                request.send();
            };
            retryLoop(0);
        };
        // Caching all files
        if (offlineProvider && offlineProvider.enableSceneOffline) {
            var noOfflineSupport_1 = function (request) {
                if (request && request.status > 400) {
                    if (onError) {
                        onError(request);
                    }
                }
                else {
                    requestFile();
                }
            };
            var loadFromOfflineSupport = function () {
                // TODO: database needs to support aborting and should return a IFileRequest
                if (offlineProvider) {
                    offlineProvider.loadFile(FileTools.BaseUrl + url, function (data) {
                        if (!aborted) {
                            onSuccess(data);
                        }
                        fileRequest.onCompleteObservable.notifyObservers(fileRequest);
                    }, onProgress ? function (event) {
                        if (!aborted) {
                            onProgress(event);
                        }
                    } : undefined, noOfflineSupport_1, useArrayBuffer);
                }
            };
            offlineProvider.open(loadFromOfflineSupport, noOfflineSupport_1);
        }
        else {
            requestFile();
        }
        return fileRequest;
    };
    /**
     * Checks if the loaded document was accessed via `file:`-Protocol.
     * @returns boolean
     */
    FileTools.IsFileURL = function () {
        return typeof location !== "undefined" && location.protocol === "file:";
    };
    /**
     * Gets or sets the retry strategy to apply when an error happens while loading an asset
     */
    FileTools.DefaultRetryStrategy = RetryStrategy.ExponentialBackoff();
    /**
     * Gets or sets the base URL to use to load assets
     */
    FileTools.BaseUrl = "";
    /**
     * Default behaviour for cors in the application.
     * It can be a string if the expected behavior is identical in the entire app.
     * Or a callback to be able to set it per url or on a group of them (in case of Video source for instance)
     */
    FileTools.CorsBehavior = "anonymous";
    /**
     * Gets or sets a function used to pre-process url before using them to load assets
     */
    FileTools.PreprocessUrl = function (url) {
        return url;
    };
    return FileTools;
}());
export { FileTools };
ThinEngine._FileToolsLoadImage = FileTools.LoadImage.bind(FileTools);
ThinEngine._FileToolsLoadFile = FileTools.LoadFile.bind(FileTools);
ShaderProcessor._FileToolsLoadFile = FileTools.LoadFile.bind(FileTools);
//# sourceMappingURL=fileTools.js.map